// ─── src/components/dashboard/NewsletterTable.tsx ────────────────────────────

import { Trash2 } from "lucide-react";
import type { NewsletterSubscriber } from "../../types/newsletter";

interface Props {
  rows: NewsletterSubscriber[];
  onDelete: (id: string) => void;
  isDeleting: boolean;
}

const SOURCE_LABEL: Record<string, string> = {
  "footer":       "Footer",
  "header-modal": "Header Modal",
};

function formatDate(iso: string) {
  return new Date(iso).toLocaleDateString("en-GB", {
    day:   "2-digit",
    month: "short",
    year:  "numeric",
  });
}

export function NewsletterTable({ rows, onDelete, isDeleting }: Props) {
  if (rows.length === 0) {
    return (
      <div className="card p-10 text-center text-brand-muted">
        No subscribers yet.
      </div>
    );
  }

  return (
    <div className="card overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="border-b border-brand-border">
              <th className="px-4 py-3 text-left text-brand-muted font-medium">#</th>
              <th className="px-4 py-3 text-left text-brand-muted font-medium">Name</th>
              <th className="px-4 py-3 text-left text-brand-muted font-medium">Email</th>
              <th className="px-4 py-3 text-left text-brand-muted font-medium">Source</th>
              <th className="px-4 py-3 text-left text-brand-muted font-medium">Subscribed</th>
              <th className="px-4 py-3 text-left text-brand-muted font-medium">Actions</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((sub, idx) => (
              <tr
                key={sub.id}
                className="border-b border-brand-border/50 hover:bg-brand-border/20 transition-colors"
              >
                <td className="px-4 py-3 text-brand-muted">{idx + 1}</td>
                <td className="px-4 py-3 text-white font-medium">{sub.name}</td>
                <td className="px-4 py-3 text-brand-muted">{sub.email}</td>
                <td className="px-4 py-3">
                  <span className="px-2 py-0.5 rounded-full text-xs bg-brand-border text-brand-muted">
                    {sub.source ? (SOURCE_LABEL[sub.source] ?? sub.source) : "—"}
                  </span>
                </td>
                <td className="px-4 py-3 text-brand-muted">{formatDate(sub.createdAt)}</td>
                <td className="px-4 py-3">
                  <button
                    onClick={() => onDelete(sub.id)}
                    disabled={isDeleting}
                    title="Remove subscriber"
                    className="p-1.5 rounded-lg text-brand-muted hover:text-red-400
                               hover:bg-red-500/10 transition-colors disabled:opacity-40"
                  >
                    <Trash2 size={14} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
